import { Spinner } from "@app/components/shadcn/spinner.tsx";

export const OverlaySpinner = () => (
  <div className="absolute inset-0 flex items-center justify-center bg-background/50 backdrop-blur-sm">
    <Spinner className="size-8" />
  </div>
);
